import styled from 'styled-components';
import { SpanLink } from '../../fuse-link/src/links';
import { gridConfig } from '../../fuse-responsive-grid/src/grid';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';

const imageRatios = {
	'1:1': '100%',
	'16:9': '56.25%',
	'4:3': '75%',
	'5:4': '80%',
	'3:4': '133.33%',
};

const spanLinkCss = (colour) => `
	span {
		color: var(${colour});
		text-decoration-color: var(${colour});
	}
`;

const StyledBody = styled(TypographyComponent).attrs({
	className: 'fuse-content-card__body',
	'data-testid': 'fuse-content-card-body-test-id',
})`
	margin-bottom: var(--spacing-global-space6);
`;

const StyledContentCard = styled.a`
	text-decoration: none;
	margin-bottom: ${({ removeMargin }) => (removeMargin ? '0' : 'var(--spacing-global-space6)')};

	&:hover {
		${spanLinkCss('--color-brand-dark')}
	}

	&:focus {
		outline: var(--spacing-global-space1) solid var(--color-functional-focus);
		outline-offset: var(--spacing-global-space2);

		${spanLinkCss('--color-brand-dark')}
	}

	&:active {
		${spanLinkCss('--color-global-black')}
	}

	> *:last-child {
		margin-bottom: 0;
	}
`;

const StyledHeading = styled(TypographyComponent).attrs({
	className: 'fuse-content-card__heading',
	'data-testid': 'fuse-content-card-heading-test-id',
})`
	margin-bottom: ${(props) =>
		props.body ? 'var(--spacing-global-space2)' : 'var(--spacing-global-space6)'};
`;

const StyledImageWrapper = styled.div.attrs({
	className: 'fuse-content-card__image-wrapper',
	'data-testid': 'fuse-content-card-image-wrapper',
})`
	margin-bottom: var(--spacing-global-space5);

	@media screen and (min-width: ${gridConfig.s.minWidth}) {
		margin-bottom: var(--spacing-global-space6);
	}

	padding-bottom: ${({ aspectRatio }) =>
		aspectRatio ? imageRatios[aspectRatio] : imageRatios['1:1']};
	position: relative;

	img {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
`;

const StyledVideoWrapper = styled.div.attrs({
	className: 'fuse-content-card__video-wrapper',
	'data-testid': 'fuse-content-card-video-wrapper',
})`
	margin-bottom: var(--spacing-global-space5);

	@media screen and (min-width: ${gridConfig.s.minWidth}) {
		margin-bottom: var(--spacing-global-space6);
	}
`;

const StyledSpanLink = styled(SpanLink).attrs({
	className: 'fuse-content-card__span-link',
	'data-testid': 'fuse-content-card-span-link-test-id',
})`
	margin-bottom: var(--spacing-global-space6);
`;

const StyledLinksWrapper = styled.div.attrs({
	className: 'fuse-content-card__links-wrapper',
	'data-testid': 'fuse-content-card-links-wrapper-test-id',
})`
	display: inline-flex;
	flex-direction: column;
	gap: var(--spacing-global-space5);
	margin-bottom: var(--spacing-global-space6);
`;

const StyledLegalText = styled(TypographyComponent).attrs({
	className: 'fuse-content-card__legal-text',
	'data-testid': 'fuse-content-card-legal-text-test-id',
})`
	color: var(--color-global-grey900);
`;

export {
	spanLinkCss,
	StyledBody,
	StyledContentCard,
	StyledHeading,
	StyledImageWrapper,
	StyledVideoWrapper,
	StyledSpanLink,
	StyledLinksWrapper,
	StyledLegalText,
};
